import { render, staticRenderFns } from "./dieBody.vue?vue&type=template&id=af99d2e8&scoped=true"
import script from "./dieBody.vue?vue&type=script&lang=js"
export * from "./dieBody.vue?vue&type=script&lang=js"
import style0 from "./dieBody.vue?vue&type=style&index=0&id=af99d2e8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "af99d2e8",
  null
  
)

export default component.exports